import { Injectable } from '@angular/core';
import { IAuthor, IThesesResource } from '../../models/itheses.interface';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { tap } from 'rxjs/operators';

export class Author implements IAuthor {
  constructor(
    public lastName: string,
    public firstName: string,
    public middleName: string = '',
    public contactEmail?: string,
    public workplace?: string,
  ) {}
}

export class ThesesResource implements IThesesResource {
  constructor(
    public mainAuthor: Author = null,
    public otherAuthor: Author[] = null,
    public thesesTitle: string = '',
    public thesesTarget: string = '',
    public thesesMaterials: string = '',
    public thesesResults: string = '',
    public thesesConclusions: string = ''
  ) {}
}

export class AbstractIdEmailMessage {
  constructor(
    public id: string = '-1',
    public emailMessage: string = ''
  ) {}
}

@Injectable({
  providedIn: 'root'
})
export class ThesesService {

  thesesResource: ThesesResource;
  thesesResult: AbstractIdEmailMessage;
  private conferenceName: string;

  private url = 'abstract';
  private api = environment.apiUrl;

  constructor(private http: HttpClient) {
    this.initResource();
  }

  initResource() {
    this.thesesResource = new ThesesResource();
    this.thesesResult = new AbstractIdEmailMessage();
  }

  pushAuthors(main: IAuthor, other: IAuthor[] = null){
    this.thesesResource.mainAuthor = main;
    this.thesesResource.otherAuthor = other;
  }

  pushThesesData(
    title,
    target,
    material,
    result,
    conclusions
  ){
    this.thesesResource.thesesTitle = title;
    this.thesesResource.thesesTarget = target;
    this.thesesResource.thesesMaterials = material;
    this.thesesResource.thesesResults = result;
    this.thesesResource.thesesConclusions = conclusions;
  }

  getTheses() {
    return this.thesesResource;
  }

  setConferenceName(name: string){
    this.conferenceName = name;
  }

  getConferenceName(): string {
    return this.conferenceName;
  }

  registrationTheses(alias: string) {
    // console.log('post');
    // console.log(this.thesesResource);
    return this.http.post(`${this.api}${this.url}/reg/${ alias }`, this.thesesResource);
  }

}
